import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Photo} from '../../models/photo.model';

@Component({
  selector: 'app-add-image',
  templateUrl: './add-image.component.html',
  styleUrls: ['./add-image.component.css']
})
export class AddImageComponent implements OnInit {

  public photo:Photo;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.photo = {} as Photo;
  }

  handleFileInput(files: FileList) {
    this.photo.url = files.item(0).name;
    this.photo.file = files.item(0);
    this.storeFileInLocalStorage(files.item(0));
  }

  storeFileInLocalStorage(file:File){
    let reader  = new FileReader();
    reader.addEventListener("load",()=>{
      //localStorage.setItem(file.name,reader.result as string);
      this.photo.data = reader.result as string;
    });
    reader.readAsDataURL(file);
  }
}
